import { render, staticRenderFns } from "./SettingsResources.vue?vue&type=template&id=63a8d97d&scoped=true&"
import script from "./SettingsResources.vue?vue&type=script&lang=js&"
export * from "./SettingsResources.vue?vue&type=script&lang=js&"
import style0 from "./SettingsResources.vue?vue&type=style&index=0&id=63a8d97d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a8d97d",
  null
  
)

export default component.exports